import React, { useState } from "react";
import Layout from "../form-layout";
import { WEIGHT_LOSS_REASONS } from "../../data/eligibility-rules";

// Q2 (Form A) / Q9 (Form B) — "What are your main reasons for wanting to lose weight?"
// Informational only, no eligibility impact.
export default function WeightLossReasons({ formData, setFormData, onBack, goToStep }) {
  const [selected, setSelected] = useState(formData.weightLossReasons || []);
  const [otherText, setOtherText] = useState(formData.otherWeightLossReason || "");

  const toggle = (reason) => {
    setSelected((prev) => (prev.includes(reason) ? prev.filter((r) => r !== reason) : [...prev, reason]));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setFormData((prev) => ({
      ...prev,
      weightLossReasons: selected,
      otherWeightLossReason: otherText,
    }));
    localStorage.setItem("weightLossReasons", JSON.stringify(selected));
    localStorage.setItem("otherWeightLossReason", otherText);

    goToStep("struggles");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        What are your main reasons for wanting to lose weight?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        {WEIGHT_LOSS_REASONS.map((reason) => (
          <label key={reason} className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
            <input
              type="checkbox"
              checked={selected.includes(reason)}
              onChange={() => toggle(reason)}
              className="h-4 w-4 accent-sky-400 cursor-pointer"
            />
            <span>{reason}</span>
          </label>
        ))}

        <label className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
          <input
            type="checkbox"
            checked={selected.includes("Other")}
            onChange={() => toggle("Other")}
            className="h-4 w-4 accent-sky-400 cursor-pointer"
          />
          <span>Other</span>
        </label>
        {selected.includes("Other") && (
          <input
            type="text"
            value={otherText}
            onChange={(e) => setOtherText(e.target.value)}
            placeholder="Please specify"
            className="border-2 border-sky-400 rounded-md p-2 text-sm w-full"
          />
        )}

        <div className="flex justify-start mt-4">
          <button
            type="submit"
            disabled={selected.length === 0}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${selected.length === 0 ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
